import { ControlWrapper } from 'components/Controls/styled'
import styled from 'styled-components'

export const Wrapper = styled(ControlWrapper)`
  width: 25px;
  display: inline-block;
  height: 100%;

  @media screen and (min-width: ${({ theme }) => theme.layout.sizes.md}px) {
    width: 40px;
  }
`
